import { render, staticRenderFns } from "./AiAnswerTree.vue?vue&type=template&id=583ad182"
import script from "./AiAnswerTree.vue?vue&type=script&lang=js"
export * from "./AiAnswerTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports